import type { NotificationPage } from "../types";
import type { ListNotificationsParams } from "./real";

/**
 * Mock do read-side. Em modo mock o histórico começa vazio e os eventos ao vivo
 * continuam vindo do `sse-mock` (que alimenta a store). As mutações são no-op —
 * a store aplica o efeito otimista localmente. Serve para validar a UI sem backend.
 */

export async function listNotifications(_params?: ListNotificationsParams): Promise<NotificationPage> {
  void _params;
  return { items: [], nextCursor: null, hasMore: false, unreadCount: 0 };
}

export async function getUnreadCount(): Promise<number> {
  return 0;
}

export async function markNotificationRead(_id: string): Promise<void> {
  void _id;
}

export async function markAllNotificationsRead(): Promise<void> {}

export async function deleteNotification(_id: string): Promise<void> {
  void _id;
}
